import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import townhall from '../../assets/townhall-icon.png';
import podium from '../../assets/dicussion-icon.png';
import fan from '../../assets/fan-icon.png';
import interview from '../../assets/interview-icon.png';
import watchparty from '../../assets/watchparty-icon.png';
import education from '../../assets/education-icon.png';


import Parallax from '../layout/Parallax';

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
        padding: theme.spacing(4),
        color: theme.palette.common.white,
    },
    header: {
        fontWeight: 700,
        lineHeight: 1,
    },
    textWrapper: {
        [theme.breakpoints.up('md')]: {
            maxWidth: '65%',
            margin: '0 auto',
        }
    },
    underline: {
        fontWeight: 300,
        // fontSize: theme.typography.h6.fontSize,
        // lineHeight: 1,
        marginTop: theme.spacing(0.5),
    },
    overline: {
        [theme.breakpoints.up('xs')]: {
            fontWeight: 300,
            fontSize: theme.typography.h5.fontSize

        },
        [theme.breakpoints.up('sm')]: {
            fontSize: theme.typography.h4.fontSize
        },
    },
    laptop: {
        maxWidth: '100%',
        width: 600
    },
    usecaseWrapper: {
        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '80%',
            margin: '0 auto',
            flexWrap: 'no-wrap',
            marginTop: theme.spacing(3)
        }

    },
    usecase: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.common.white,
        padding: theme.spacing(2),
        borderRadius: theme.spacing(0.5),
        margin: theme.spacing(1),
        [theme.breakpoints.up('xs')]: {
            width: '100%'
        },
        [theme.breakpoints.up('sm')]: {
            width: 300
        },
        [theme.breakpoints.up('md')]: {
            width: 400
        }
    },
    usecaseImage: {
        height: 100,
        marginRight: theme.spacing(2)
    },
    nanoMeet: {
        fontWeight: 700
    }
}))


export default function Usecases(props) {
    const classes = useStyles();
    const usecases = [
        { title: "Townhall meetings", underline: "like company webcasts", image: townhall },
        { title: "Podium discussions", underline: "like expert sessions", image: podium },
        { title: "Interviews and announcements with Q&A", underline: "like press briefings", image: interview },
        { title: "Live events", underline: "like music, comedy, ...", image: fan },
        { title: "Education", underline: "like remote learning", image: education },
        { title: "Watch parties", underline: "watch a live stream together and discuss", image: watchparty },
    ]

    return (
        <Parallax>
            <div className={classes.root}>
                <div className={classes.textWrapper}>
                    <Typography variant="h4" className={classes.overline}>
                        There are various live streaming use cases with audience engagement that can be created using <b className={classes.nanoMeet}>nanoMeet</b>.
                    </Typography>
                </div>
                <div className={classes.usecaseWrapper}>
                    {
                        usecases.map((usecase) => (
                            <div key={usecase.title} className={classes.usecase}>
                                <img className={classes.usecaseImage} src={usecase.image} />
                                <div>
                                    <Typography className={classes.header} variant="h5">
                                        {usecase.title}
                                    </Typography>
                                    <Typography className={classes.underline} variant="h6">
                                        {usecase.underline}
                                    </Typography>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </Parallax>
    )
}